import React, { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function InterstellarGateway() {
  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [bgIndex, setBgIndex] = useState(0);
  const titles = ["Fiber Optic.", "FPV Drones.", "AI Infrastructure."];
  const backgroundImages = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/interstellar_gateway_fiber_optic.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/interstellar_gateway_fpv_drone.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/interstellar_gateway_ai_data_center.png"];
  useEffect(() => {
    const i = loopNum % titles.length;
    const fullText = titles[i];
    const typingTime = 2500;
    const pauseTime = 3000;
    const deletingTime = 500;
    const currentDelay = isDeleting ? deletingTime / fullText.length : typingTime / fullText.length;
    const handleTyping = () => {
      setText(isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1));
      if (!isDeleting && text === fullText) {
        setTimeout(() => setIsDeleting(true), pauseTime);
      } else if (isDeleting && text === "") {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
      }
    };
    const timer = setTimeout(handleTyping, currentDelay);
    return () => clearTimeout(timer);
  }, [text, isDeleting, loopNum, titles]);
  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex(prev => (prev + 1) % backgroundImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [backgroundImages.length]);
  return <section data-section-id="9281" id="connecting-intelligence" className="dark relative h-screen w-full overflow-hidden bg-background text-foreground">
      <div className="absolute inset-0 z-0">
        {backgroundImages.map((src, i) => <img key={src} data-index={i} src={src} alt={titles[i]} className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-2000 ${i === bgIndex ? "opacity-80" : "opacity-0"}`} />)}
        <div className="absolute inset-0" />
      </div>

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        <div className="space-y-6">
          <h1 className="font-sans text-5xl font-bold tracking-tighter sm:text-7xl md:text-8xl lg:text-9xl">
            <span className="bg-gradient-to-r from-foreground to-primary bg-clip-text text-transparent drop-shadow-[0_0_40px_rgba(0,255,255,0.4)]">
              CONNECTING INTELLIGENCE: FIBER, AI & DRONES
            </span>
          </h1>

          <div className="font-mono text-lg text-primary sm:text-xl md:text-2xl">
            <span className="border-r-2 border-primary pr-1 animate-pulse">
              {text}
            </span>
          </div>

          <div className="pt-8">
            <Button asChild size="lg" className="relative h-14 overflow-hidden rounded-xl border border-primary/50 bg-primary/10 px-8 text-lg font-bold uppercase tracking-widest text-primary backdrop-blur-md transition-all duration-300 hover:bg-primary/20 hover:shadow-[0_0_50px_rgba(0,255,255,0.5)] hover:text-foreground">
              <Link to="#">
                <span className="relative z-10 flex items-center gap-2">
                  Explore Solutions
                </span>
                <span className="absolute inset-0 -z-10 animate-pulse bg-primary/10" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 z-20 -translate-x-1/2 animate-bounce">
        <Link to="#products" className="flex flex-col items-center gap-2 text-sm font-medium uppercase tracking-widest text-muted-foreground transition-colors hover:text-primary">
          <span className="text-[10px] font-mono">Discover Innovation</span>
          <ChevronDown className="h-6 w-6 text-primary drop-shadow-[0_0_15px_rgba(0,255,255,0.6)]" />
        </Link>
      </div>
    </section>;
}